<template>
  <div class="layout-container">
    <!-- 左侧内容 -->
    <div class="layout-left">
      <div class="content-wrapper-layout">
        <slot name="left"></slot>
      </div>
    </div>

    <!-- 右侧内容 -->
    <div class="layout-right">
      <div class="content-wrapper-layout">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SplitLayout',
  props: {
    // 可以添加需要的props
  },
};
</script>

<style lang="scss" scoped>
.layout-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  position: relative;

  // 左右布局
  @media screen and (min-width: 992px) {
    .layout-left,
    .layout-right {
      width: 50%;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      position: relative;
    }

    .layout-right {
      box-shadow: -10px 0 20px -10px rgba(0, 0, 0, 0.1);
    }

    .content-wrapper-layout {
      padding-top: 90px;
      padding-bottom: 90px;
      width: calc(100% - 220px); // 两边各90px的间距
      flex: 0 0 auto;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .layout-left .content-wrapper-layout {
      margin-left: auto;
      margin-right: 110px;
      align-items: flex-end; // 右对齐
    }

    .layout-right .content-wrapper-layout {
      margin-right: auto;
      margin-left: 110px;
      align-items: flex-start; // 左对齐
    }
  }

  // 上下布局
  @media screen and (max-width: 991px) {
    flex-direction: column;

    .layout-left,
    .layout-right {
      width: 100%;
    }
    .layout-left{
      padding-top: 20px;
    }
    .layout-right {
      .content-wrapper-layout {
        width: 366px;
        margin: 0 auto;
        padding: 20px 0;

        > :deep(*) {
          width: 100%;
          max-width: 100%;
          box-sizing: border-box;
        }
      }
    }
    .content-wrapper-layout {
      width: 100%;
      max-width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 20px;
      box-sizing: border-box;
    }
  }
}
</style>
